var performanceTracking = require('./performanceTracking');

performanceTracking.init();



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/performanceTracking/init.js
 ** module id = 885
 ** module chunks = 0
 **/